import { AxiosPromise } from 'axios'
import { stringify } from 'query-string'
import axios from '../api/axios'
import { Language } from '../locale/enums'
import { Category } from './types'

export const getCategories = (language: Language | undefined): AxiosPromise<Category[]> =>
  axios.get<Category[]>(`/wp/v2/categories?${stringify({ lang: language })}`)
